/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ClockRoot from '../clock/clock-root';

import template from './setup-panel-right.html';

export default {
  name: 'SetupPanelRight',
  template,
  components: { ClockRoot },
  computed: {
    className() {
      if (this.isOnline) {
        return 'setup-connectivity--online';
      }
      return 'setup-connectivity--offline';
    }
  },
  data() {
    return {
      delay: 1000
    };
  },
  props: ['isOnline']
};
